import { app } from "@microsoft/teams-js";
import { AccountInfo } from "@azure/msal-browser";
import { microsoftClientId } from '@shared/services/EnvironmentVariables';

const userAgent = window.navigator.userAgent.toLowerCase();
const isTeamsUserAgent = userAgent.includes('teams');

const url = window.location.href.toLowerCase();
const isTeamsUrl = url.includes('teams.microsoft');

const host = window.location.host.toLowerCase();
const isTeamsHost = host.includes('teams.microsoft');

export async function isInTeamsApp() {
  try {
    await app.initialize();
    return true;
  } catch (e) {
    return false;
  }
}

function isInIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

const OUTLOOK_HOST_PATTERNS = [
  'outlook.office.com',
  'outlook.office365.com',
  'outlook.live.com',
  'outlook.cloud.microsoft',
];

export function isInOutlook(): boolean {
  const ua = window.navigator.userAgent;
  if (
    ua.includes('Outlook-IOS') ||
    ua.includes('Outlook-Android') ||
    ua.includes('Outlook/') ||
    ua.includes('MSOffice')
  ) {
    return true;
  }

  const href = window.location.href.toLowerCase();
  if (OUTLOOK_HOST_PATTERNS.some(p => href.includes(p))) {
    return true;
  }

  // When loaded as an Outlook add-in our own location is app.team-today.com,
  // so the parent frame's origin is the only reliable signal.
  const ancestors = window.location.ancestorOrigins;
  if (ancestors) {
    for (let i = 0; i < ancestors.length; i++) {
      const origin = ancestors[i].toLowerCase();
      if (OUTLOOK_HOST_PATTERNS.some(p => origin.includes(p))) {
        return true;
      }
    }
  }

  return false;
}

export function isInTeams() {
  return isTeamsUserAgent || isTeamsUrl || isTeamsHost || window.parent !== window || isInOutlook() || isInIframe();
}

export function isInTeamsSettingsTab() {
  return isInTeams() && window.location.href.includes('/manage');
}

export function isInCompanyTab() {
  return isInTeams() && window.location.href.includes('/whereabouts/company');
}

export function isInTeamsTab() {
  return isInTeams() && !isInCompanyTab() && window.location.href.includes('/whereabouts');
}

export function deepLinkTo(tabId: string, externalUrl: string, type?: 'user' | 'search' | 'leave' | 'floor' | 'team' | 'tag' | 'personal' | 'add-users', id?: string | number) {
  let qs =`&context={"subEntityId": "${type ?? ''}:${id ?? ''}:${Date.now()}"}`;
  const url = `https://teams.microsoft.com/l/entity/${microsoftClientId}/${tabId}?webUrl=${externalUrl}${qs}`;
  return app.openLink(url);
}

export function getLinkIdFromSubEntityId(subEntityId?: string) {
  if (!subEntityId) return;
  const split = subEntityId.split(":");
  if (split.length !== 3) return;
  return split[2];
}

export function isInTeamsStoreApp() {
  return isInTeams() && localStorage.getItem('isInTeamsStoreApp') === 'true';
}

export function setInTeamsStoreApp() {
  return localStorage.setItem('isInTeamsStoreApp', 'true');
}

export function resetInTeamsStoreApp() {
  return localStorage.removeItem('isInTeamsStoreApp');
}

function findLoginAccount(context: app.Context, accounts: AccountInfo[]): AccountInfo | undefined {
  const principleName = context.user?.userPrincipalName;
  const loginHint = context.user?.loginHint;
  return accounts.find(account => account.username === loginHint) ?? accounts.find(account => account.username === principleName)
}
